import { RemixiconComponentType } from '@remixicon/react';

export const AverageIcon: RemixiconComponentType = ({
  size = 24,
  color = 'currentColor',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <path d="M19 8.41L17.59 7L12 12.59L6.41 7L5 8.41L10.59 14L5 19.59L6.41 21L12 15.41L17.59 21L19 19.59L13.41 14L19 8.41Z" />
    <path d="M4 3h16v2H4V3Z" />
  </svg>
);
